import { render } from "./NavbarAll.vue?vue&type=template&id=1cab67e4&scoped=true"
import script from "./NavbarAll.vue?vue&type=script&lang=js"
export * from "./NavbarAll.vue?vue&type=script&lang=js"

import "./NavbarAll.vue?vue&type=style&index=0&id=1cab67e4&scoped=true&lang=css"

import exportComponent from "E:\\dipto_projects\\parcel\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cab67e4"]])

export default __exports__